<template>
<v-container fluid>
    <v-card class="ma-2" flat>
        <!-- <v-card-title>
            รายโปรแกรม
            <v-spacer></v-spacer>
            <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
            <v-btn color="primary" dark class="ml-5 mt-3" @click="addNewItem" v-if="isAccessCoachAdmin">
                + ADD
            </v-btn>
        </v-card-title> -->
    </v-card>
</v-container>
</template>

<script>
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import {
    mapGetters
} from "vuex";
export default {
    name: 'ProgramManagement',
    metaInfo: {
        title: 'Program Management'
    },
    data() {
        return {
            loading: false
        };
    },
    created() {
        var vm = this;
        vm.$store.state.appTitle = "Thaisook Web Admin | Program";
        firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                vm.$store.dispatch("autoSignIn", user);
                this.loading = true;
                setTimeout(() => {
                    vm.initialize();
                }, "1000");
            } else {
                console.log("no user");
            }
        });
    },
    computed: {
        ...mapGetters([
            "loggedInUserId",
            "isAuthenticated",
            "isSuperAdmin",
            "isChallengeAdmin",
            "isAccessCoachAdmin",
        ]),
    },
    methods: {
        initialize() {
            if (this.isSuperAdmin || this.isAccessCoachAdmin ) {
                if( this.isAccessCoachAdmin ){
                    this.$router.push(`/program/member-list`);
                }
                else{
                    this.$router.push(`/program/program-list`);
                }
                this.loading = false;
            } else {
                this.$router.push(`/dashboard`);
            }
        }
    }
};
</script>
